module.exports = __webpack_public_path__ + "static/media/icons-pattern.e463307c.svg";